import assertNever from "assert-never";
import React from "react";
import { EngagementStatus } from "../messages/Visit";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppButton } from "./Generic/AppButton";

interface Props {
  status: EngagementStatus;
  isRequestPermitted: boolean;
  isSingleShift: boolean;
  onClickRequest: () => void;
  onClickReject: () => void;
  onClickCancel: () => void;
}

const AvailableVisitFooter = (props: Props) => {
  return (
    <div className="AvailableVisitFooter">
      <EngagementButton {...props} />
    </div>
  );
};

const EngagementButton = (props: Props) => {
  switch (props.status) {
    case "AVAILABLE":
      return (
        <>
          <AppButton
            data-type="REQUEST"
            onClick={props.onClickRequest}
            disabled={!props.isRequestPermitted}
          >
            {props.isSingleShift
              ? translate(STRINGS.REQUEST_SELECTED_SHIFT)
              : translate(STRINGS.REQUEST_SELECTED_SHIFTS)}
          </AppButton>
          <AppButton
            data-type="REJECT"
            variant="link"
            color="black"
            size="small"
            onClick={props.onClickReject}
          >
            {translate(STRINGS.REJECT_THIS_VISIT)}
          </AppButton>
        </>
      );
    case "REQUESTED":
      return (
        <>
          <AppButton
            data-type="REQUESTED"
            variant="outline"
            color="black"
            onClick={props.onClickCancel}
          >
            {`${translate(STRINGS.REQUESTED)} (${translate(STRINGS.TAP_TO_CANCEL)})`}
          </AppButton>
        </>
      );
    case "PENDING_CONFIRMATION":
      return <></>;
    default:
      assertNever(props.status);
  }
};

export default AvailableVisitFooter;
